import React, { useState } from 'react';
import styles from './NavLayout.module.scss';
import { IconMyCollection, IconTransitions, ausPrimaySchoolProgramsMenuOptions } from '@src/constants';
import { LordIcon } from '@src/components/lord-icon/lord-icon';
import { Dropdown} from "antd";

type Props = {
  programName: string;
  isCanada?: boolean;
  isAUuser?: boolean;
  handleSelectProgram?: (program: string) => void;
}

const getIconByProgram = (program: string) => {
  switch (program) {
    case ausPrimaySchoolProgramsMenuOptions[0].label:
      return IconMyCollection;
    case ausPrimaySchoolProgramsMenuOptions[1].label:
      return IconTransitions;
    default: {
      return IconTransitions;
    }
  }
}


function NavLayout(props: Props) {
  const { programName } = props;

  const [showProgramMenu, setShowProgramMenu] = useState(false);

  const IconSrc = getIconByProgram(programName);

  return (
    <>
      <div id={"navMenuBar"} className={styles.navView}>
        <div className={styles.itemWrapper}>
          <Dropdown menu={{ items: [] }} trigger={[]} placement="bottom" onOpenChange={(visible) => setShowProgramMenu(visible)} open={showProgramMenu}>
            <div className={[styles.listItem, styles.selItem].join(' ')}>
              <LordIcon src={IconSrc} isHover={true} colors={{primary: '#FFB073', secondary: '#FFB073'}} target='.NavLayout_gradeDropDownMenuitem__sBqfP' size={60}/>
              <div className={[styles.listTitle, styles.selItemTitle].join(' ')}>
              {programName}
              </div>
            </div>
          </Dropdown>
        </div>
      </div>
    </>
  );
}

export default NavLayout;
